var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M2.1875 13.2812H12.8125C13.0687 13.2812 13.2812 13.4938 13.2812 13.75C13.2812 14.0063 13.0687 14.2188 12.8125 14.2188H2.1875C1.93125 14.2188 1.71875 14.0063 1.71875 13.75C1.71875 13.4938 1.93125 13.2812 2.1875 13.2812Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M11.875 9.075C11.6187 9.075 11.4062 8.8625 11.4062 8.60625V3.31875L3.45625 11.2688C3.3625 11.3625 3.24375 11.4062 3.125 11.4062C3.00625 11.4062 2.8875 11.3625 2.79375 11.2688C2.6125 11.0875 2.6125 10.7875 2.79375 10.6062L10.7438 2.65625H5.45625C5.2 2.65625 4.9875 2.44375 4.9875 2.1875C4.9875 1.93125 5.2 1.71875 5.45625 1.71875H11.875C11.9375 1.71875 11.9937 1.73125 12.0562 1.75625C12.1687 1.8 12.2625 1.89375 12.3063 2.00625C12.3313 2.06875 12.3438 2.125 12.3438 2.1875V8.60625C12.3438 8.8625 12.1312 9.075 11.875 9.075Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }